import Grid from '@mui/material/Grid';
import "./style.css";
import React from 'react';
import {useState, useEffect} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
import axios from 'axios';
import { Phone, Search, } from "@mui/icons-material";
import { IconButton, Checkbox, Box, Typography} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import PhoneInput, { getCountries, getCountryCallingCode, isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css'
import { formatPhoneNumberIntl } from 'react-phone-number-input'
import { formatPhoneNumber } from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
import MenuItem from '@mui/material/MenuItem';
import FormLabel from '@mui/material/FormLabel';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Select, FormControl, InputLabel } from '@mui/material';

export default function PaymentDetail({changeStat, contractReq, setContractReq}){
    const [paidDate, setpaidDate] = useState(new Date());

    const handleDateChange = (date) => {
        setpaidDate(date);
        const piDate = date.getDate();
        const longMonth = date.toLocaleString('default', { month: 'long' });
        const piYear = date.getFullYear();
        console.log(piDate + " " + longMonth + " " + piYear);
    }
    const [error,setError]=useState();
    const changetoPaid =() => {
        if(contractReq){
        changeStat(paidDate)
    }else{
        setError("Pilih jawaban diatas")
    }
    }
    

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Grid container justifyContent="center" sx={{p:5,}}>
                <Grid item sm={6}>
                    <MobileDatePicker 
                        views={['year', 'month', 'day']}
                        inputFormat="dd/MM/yyyy"
                        label="Tanggal Pembayaran"
                        value={paidDate}
                        onChange={handleDateChange}
                        renderInput={(params) => 
                            <TextField 
                                {...params} 
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <CalendarMonthIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        }
                    />
                </Grid>
                <Grid container sx={{mt:3, mb:3}} justifyContent="center" alignItems="center">
                    <FormControl variant="outlined">
                        <Typography>Apakah Butuh Kontrak?</Typography>
                        <Select
                        labelId="contract-select-label"
                        id="contract-select"
                        value={contractReq}
                        onChange={(event)=>setContractReq(event.target.value)}
                        >
                        <MenuItem value={"ya"}>Ya: Ini VO/PO Baru</MenuItem>
                        <MenuItem value={"ya_extend"}>Ya: Ini Extend Virtual Office</MenuItem>
                        <MenuItem value={"tidak_yakin"}>Tidak Yakin: Ini Extend Private Office</MenuItem>
                        <MenuItem value={"tidak_tipe"}>Tidak: Bukan Kontrak VO/PO</MenuItem>
                        <MenuItem value={"tidak_pelunasan"}>Tidak: Ini adalah Pelunasan</MenuItem>
                        <MenuItem value={"tidak"}>Tidak!</MenuItem>
                        
                        </Select>
                    </FormControl>
                    </Grid>
                    {error && <Grid className="error_text" sx={12} xs={{mr:2}}>{error}</Grid>}
                        <Grid sx={{pl:5}}>
                <Button variant="contained" onClick={() => changetoPaid()}>
                    Done
                </Button>
                </Grid>

            </Grid>
            
        </LocalizationProvider>
    );
}